import React, { useEffect, useState } from 'react'
import { BasicHabilitationAccordion } from '../access/HabilitationAccordion'
import { RESOURCE } from '../../../constants/ApplicationHabilitationConstants'
import i18n from '../../../../../../simple-react-i18n'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import ResourceAction from '../../../../../../resource/actions/ResourceAction'
import ResourceDto from '../../../../../../resource/dto/ResourceDto'

const HabilitationResouce = ({}) => {
    const dispatch = useDispatch()
    const {
        resources,
    } = useSelector(store => ({
        resources: store.ResourceReducer.resources,
    }), shallowEqual)

    const [isLoaded, setIsLoaded] = useState(false)

    useEffect(() => {
        if (resources.length === 0) {
            dispatch(ResourceAction.fetchResources())
                .then(() => setIsLoaded(true))
        } else {
            setIsLoaded(true)
        }
    }, [dispatch])

    return (
        <BasicHabilitationAccordion
            stationType={RESOURCE}
            title={i18n.resource}
            stations={resources}
            isLoaded={isLoaded}
        />
    )
}

HabilitationResouce.propTypes = {
    resources: PropTypes.arrayOf(PropTypes.instanceOf(ResourceDto)),
    fetchResources: PropTypes.func,
}

export default HabilitationResouce